export default "__VITE_ASSET__54b77fa9__"